import { TagResource } from "@/services";
import { catchErrors } from "../../lib/errorHandlers";
import Vue from "vue";

const state = {
  tags: [],
  popularTags: null,
  loading: false,
  loaded: false
};

const getters = {
  getAll: state => state.tags,
  getLoaded: state => state.loaded,
  getByCode: state => code => {
    return state.tags.find(tag => tag.code === code) || null;
  },
  getById: state => id => {
    return state.tags.find(tag => tag.id === id) || null;
  },
  getByIds: state => ids => {
    ids = ids.map(id => parseInt(id));

    let tags = state.tags.filter(tag => ids.indexOf(parseInt(tag.id)) >= 0);
    return tags;
  },
  getByName: state => name => {
    return state.tags.filter(
      tag => tag.name.toLowerCase().indexOf(name.toLowerCase()) >= 0
    );
  }
};

const actions = {
  async getTags({ state, commit }) {
    return catchErrors(async () => {
      const response = await TagResource.get();
      const tags = response.data;

      commit("setTags", tags);
    }, "Unable to load <strong>Tags</strong>");
  }
};

const mutations = {
  setLoading(state, val) {
    state.loading = val;
  },
  setTags(state, tags) {
    Vue.set(state, "tags", tags);
    Vue.set(state, "loaded", true);
  },
  setPopularTags(state, tags) {
    Vue.set(state, "popularTags", tags);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
